var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_33",
    "data-name": "Grupo 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 129.034,
    height: 157.249,
    viewBox: "0 0 129.034 157.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_81",
    "data-name": "Ret\\xE2ngulo 81",
    width: 129.034,
    height: 157.248,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_191",
    "data-name": "Caminho 191",
    d: "M19.647,40.321a67.4,67.4,0,0,1,.475-38.432",
    transform: "translate(19.958 2.207)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_192",
    "data-name": "Caminho 192",
    d: "M43.685,47.838c18.715-7,31.415-22.085,31.6-39.546H52.595",
    transform: "translate(51.039 9.688)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_193",
    "data-name": "Caminho 193",
    d: "M23.755,8.294H1.25c.189,17.46,12.891,32.549,31.608,39.542",
    transform: "translate(1.46 9.69)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_79",
    "data-name": "Ret\\xE2ngulo 79",
    width: 75.012,
    height: 37.506,
    transform: "translate(27.015 117.032)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_194",
    "data-name": "Caminho 194",
    d: "M16.3,76.755V59.714a1.9,1.9,0,0,1,1.9-1.9H72.746a1.9,1.9,0,0,1,1.9,1.9V76.755a1.9,1.9,0,0,1-1.9,1.9H18.2a1.9,1.9,0,0,1-1.9-1.9",
    transform: "translate(19.046 67.55)",
    fill: "#ff8924"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_80",
    "data-name": "Ret\\xE2ngulo 80",
    width: 37.506,
    height: 10.614,
    transform: "translate(45.769 106.418)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_195",
    "data-name": "Caminho 195",
    d: "M56.548,104.793V80.984A68.623,68.623,0,0,0,90.234,21.63a69.6,69.6,0,0,0-3.04-20.38H14.669a69.6,69.6,0,0,0-3.04,20.38,68.632,68.632,0,0,0,33.69,59.354v23.808",
    transform: "translate(13.587 1.46)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.792d38c66dcc1d4ad6e325270907ce4c.svg";
export { ForwardRef as ReactComponent };